<template>
  <div
    v-if="loaded"
    class="vehicle-bar"
    :class="{
      'bg-success--variant': positive,
      'bg-danger': !positive
    }"
  >
    <div class="container-fluid">
      <div class="row wrap">
        <div class="col-xs-12">
          <div class="row middle-sm selected-vehicle-bar">
            <div class="col-xs-12">
              <SfIcon class="credit-icon" icon="credits" size="16px" /> {{ }}
              <span>{{ $t('Credit Limit') }}: {{ currencyFormatter().format(limit) }}</span>{{ }}
              <SfIcon class="add-to-cart-icon" icon="add_to_cart" size="16px" /> {{ }}
              <span>{{ $t('Left') }}: {{ currencyFormatter().format(left) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SfIcon } from '@storefront-ui/vue';
import { config } from '@/modules/core';

export default {
  name: 'CreditLimit',
  mixins: [config],
  components: {
    SfIcon,
  },
  created() {
    this.fetchCreditLimit()
      .then((data) => {
        this.balance = data.Balance;
        this.limit = data.Limit;
      })
      .finally(() => {
        this.loaded = true;
      });
  },
  data() {
    return ({
      balance: 0,
      limit: 0,
      loaded: false,
    });
  },
  computed: {
    left() {
      return this.limit - this.balance;
    },
    positive() {
      return this.left >= 0;
    },
  },
  methods: {
    ...mapActions({
      fetchCreditLimit: 'level4/fetchCreditLimit',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

.container-fluid {
  padding: 1rem;
  text-align: center;
}

.credit-icon, .add-to-cart-icon {
  position: relative;
  display: inline-block;
  top: 3px;
}

.add-to-cart-icon {
  margin-left: 10px;
}

a {
  // margin-right: var(--spacer-sm);
  font-size: var(--font-sm);
  font-family: var(--font-family-secondary);
  font-weight: var(--font-medium);
  color: var(--c-text);
  &:hover {
    color: var(--_c-blue-primary);
  }
}
</style>
